import { put, call } from 'redux-saga/effects';
import {
    getRecommendedPrescriptionSuccessAction,
    getRecommendedPrescriptionFailureAction,
    createPrescriptionSuccessAction,
    createPrescriptionFailureAction,
    getPatientPrescriptionSuccessAction,
    getPatientPrescriptionFailureAction,
    getPatientPrescriptionRequestAction
} from '../actions/prescriptionActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

// ------ get recommeded prescription ------

export function* getRecommendedPrescription(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const prescriptionResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.recommendedPrescription(action.payload.consultationId, action.payload.type)}`,
        );
        if (!prescriptionResponse.success) {
            throw new Error(prescriptionResponse.message)
        }
        yield put(getRecommendedPrescriptionSuccessAction(prescriptionResponse.data, action.payload.type));
    } catch (error) {
        yield put(getRecommendedPrescriptionFailureAction(error.message));
    }
}

export function* createPrescription(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const prescriptionResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.createPrescription}`,
            {
                ...action.payload.body
            }
        );
        if (!prescriptionResponse.success) {
            throw new Error(prescriptionResponse.message)
        }
        yield put(createPrescriptionSuccessAction(prescriptionResponse.data));
        yield put(getPatientPrescriptionRequestAction(action.payload.body.consultationId))
    } catch (error) {
        yield put(createPrescriptionFailureAction(error.message));
    }
}

export function* getPatientSavedPrescription(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const prescriptionResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.getSavedPrescription(action.payload.consultationId)}`,
        );
        if (!prescriptionResponse.success) {
            throw new Error(prescriptionResponse.message)
        }
        yield put(getPatientPrescriptionSuccessAction(prescriptionResponse.data));
    } catch (error) {
        yield put(getPatientPrescriptionFailureAction(error.message));
    }
}
